module.exports = __webpack_public_path__ + "static/ada2-8a7b3eb456843f68b9bcf64b90be296a.jpg";